import { Timestamp, onSnapshot, setDoc } from 'firebase/firestore';
import { makeSubcollection } from './subcollection';

// Community votes at `tournaments/{id}/communityVotes/{uid}`: one doc per
// voter, `{ userId, username, votes: { [key]: rating 1-10 }, updatedAt }`.
// Shared with the legacy mapping format, so firestore.rules already apply:
// voters write only their own doc and only while `votingOpen != false`;
// the docs can be listed by tournament admins, and by everyone once
// `communityAverageVisible` is true. Staged keys come from voteKey() in
// src/lib/stages.js.
const votes = makeSubcollection('communityVotes');

// Every voter's doc. Returns the unsubscribe function.
export const subscribeVotes = (tournamentId, onData, onError) =>
  onSnapshot(
    votes.col(tournamentId),
    (snap) => onData(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    onError
  );

// The signed-in voter's own ratings, `{ [key]: rating }`.
export const subscribeOwnVotes = (tournamentId, uid, onData, onError) =>
  onSnapshot(
    votes.ref(tournamentId, uid),
    (snap) => onData(snap.exists() ? snap.data().votes || {} : {}),
    onError
  );

export const castVote = async (tournamentId, user, key, rating) => {
  if (!Number.isInteger(rating) || rating < 1 || rating > 10) {
    throw new Error('Pick a rating from 1 to 10.');
  }
  await setDoc(
    votes.ref(tournamentId, user.uid),
    {
      userId: user.uid,
      username: user.displayName || user.email || '',
      votes: { [key]: rating },
      updatedAt: Timestamp.now(),
    },
    { merge: true }
  );
};
